const createStandartGermanDate = (date) => {
  const new_date = new Intl.DateTimeFormat("de-DE", {
    timeZone: "Europe/Berlin",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).format(new Date(date))
  const date_string = new_date.toString()

  return date_string
}

module.exports = createStandartGermanDate
